import * as React from "react";
import { FieldValueCheckbox } from "typings/index";
import { Checkbox } from "office-ui-fabric-react/lib";
import { BaseFieldEditor } from "./helper";

export interface Props extends BaseFieldEditor
{
    value: FieldValueCheckbox;
}

class Boolean extends React.Component<Props>
{

    onValueChange = () =>
    {
        const propValue = this.props.value; 
        const value = propValue === undefined || propValue.value === false ? true : false;
        const fieldValue: FieldValueCheckbox = {...propValue, value };
        this.props.onValueChange(fieldValue);
    }

    render()
    {
        const propValue = this.props.value; 
        const value = propValue && propValue.value ? propValue.value : false;
        return <div>
            <Checkbox disabled={this.props.disabled} onChange={this.onValueChange} checked={value} />
        </div>;
    }
}

export default Boolean;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/Boolean.tsx